<template>
    <div id="crbg-content">
        <div v-if="list && !id">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <h1 id="crbg-header" class="text-uppercase">News</h1>
                    <img src="/images/crbg/learning-center/main-image.jpg" class="embed-responsive" alt="Main learning image"/>
                </div>
            </div>
            <div class="row justify-content-center mt-4">
                <div class="col-md-12 text-center mb-4">
                    <div class="accordion sb-accordion" id="accordionExample">
                        <div class="card">
                            <div id="headingOne" class="card-header" :class="dropdownIsOpen">
                                <h2 class="mb-0">
                                    <button
                                        class="btn dropdown-toggle"
                                        :class="dropdownIsOpen"
                                        type="button"
                                        data-toggle="collapse"
                                        @click="categoryDropDown=!categoryDropDown"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                        aria-label="Select A Category"
                                    >
                                        <i class="fas" :class="chevronDirection"></i>
                                            Select A Category
                                        <span>({{selectedCategory?selectedCategory:'ALL'}})</span>
                                    </button>
                                </h2>
                            </div>

                            <div id="collapseOne" :class="categoryDropDown?'collapse show':'collapse'" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <a id="category_all"
                                       class="dropdown-item"
                                       aria-label="All Categories"
                                       tabindex="0"
                                       href="#"
                                       @click.prevent="omniSearch.category='';categoryDropDown=false;renderList();selectedCategory=''">
                                        All
                                    </a>
                                    <a
                                        v-if="categories.length > 0"
                                        v-for="category in onlyActives(categories)"
                                        class="dropdown-item"
                                        tabindex="0"
                                        href="#"
                                        :aria-label="category.dop_name"
                                        @click.prevent="omniSearch.category = category.dop_id; categoryDropDown = false; renderList() ; selectedCategory = category.dop_name"
                                        :id="'category_link_' + category.dop_id"
                                    >
                                        {{category.dop_name}}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 mb-3" v-for="content in paginatedContents" v-if="(speciality=='N' || (content.sco_title!='Introducing SWORD Health' && content.sco_title!='Coverage of Over-the-Counter (OTC) COVID-19 Testing'))">
                    <div class="card border-0 sb-learning-center__card">
                        <div class="sb-learning-center" :style="getContentStyle(content,'')">
                            <div class="carousel-caption text-center">
                                <span>{{content.sco_title}}</span>
                                <br/>
                                <div class="text-center">
                                    <a href="" class="btn btn-primary btn-sb-red" @click.prevent="show(content)" :aria-label="('Read Now - ' + content.sco_title)" >Read Now</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <pagination
                v-if="showPagination"
                :records="contents.length"
                v-model="page"
                :per-page="perPage"
                :options="options"
            ></pagination>
        </div>
        <div v-if="view">
            <div v-if="content === null || content === undefined">
                <div v-if="wellnessrewardPage()">
                    <div class="alert alert-info" role="alert">
                        <h4 class="alert-heading">Warning!</h4>
                        <p>You are not yet eligible to opt in for Wellness Rewards.  Please check back later.</p>
                    </div>
                </div>
                <div v-else>
                    <div class="alert alert-info" role="alert">
                        <h4 class="alert-heading">Warning!</h4>
                        <p>Content isn't available at the moment. Please check back later.</p>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="content" class="row justify-content-center">
                    <div class="col-md-9 mb-3"></div>
                    <div v-if="id == undefined" :class="wellnessrewardssitecontentid!=content.sco_id?'col-md-3 text-right back-btn__mobile':'col-md-3 text-right back-btn__mobile mb-5'">
                        <a class="btn btn-primary btn-sb-red sb-back-to-learning-center"
                           v-if="wellnessrewardssitecontentid!=content.sco_id"
                           tabindex="0"
                           aria-label="Back To News"
                           href="#"
                           @click.prevent="render('list')">Back To News</a>
                    </div>
                    <div v-else :class="wellnessrewardssitecontentid!=content.sco_id?'col-md-3 text-right back-btn__mobile':'col-md-3 text-right back-btn__mobile mb-5'">
                        <a class="btn btn-primary btn-sb-red sb-back-to-learning-center"
                           v-if="wellnessrewardssitecontentid!=content.sco_id"
                           tabindex="0"
                           aria-label="Back To News"
                           href="/learning-center/"
                        >Back To News</a>
                    </div>
                </div>
                <div class="row justify-content-center sb-wt-bg sb-learning-center__bg">
                    <div class="col-md-12">
                        <div  class="main-content-image mt-3" :style="getContentStyle(content,'display:none')"></div>
                    </div>
                </div>
                <div class="row justify-content-center pt-4 sb-wt-bg pb-4">
                    <div class="col-md-12 sb-learning-center-content">
                        <h3 class="text-center">{{content.sco_title}}</h3>
                        <div class="ql-editor" v-html="content.sco_desc_long"></div>
                    </div>
                    <div class="col-md-12 text-left">
                        <a v-if="content.file" class="btn btn-primary btn-sb-red" :href="content.content_path+'/'+content.file" target="_blank">View Document</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Pagination from 'vue-pagination-2';

export default {
    components: {
        Pagination
    },
    data() {
        return {
            route: '/api/content',
            view: false,
            list: !this.view,
            categoryDropDown:false,
            contents: [],
            content:false,
            categories: [],
            features: [],
            omniSearch: { category: '',status:'A' },
            search: {},
            selectedCategory:'',
            page: 1,
            perPage: 6,
            options: {
                'chunk': 5
            },
            showPagination: false,
            permanentCategories: 'waiting',
            permanentContents: []
        }
    },
    props:['id','speciality','wellnessrewardssitecontentid'],
    mounted: function () {
        this.renderList().then(this.addLabelToPaginationButtons);
        this.loadData();

        this.$nextTick(() => {
            this.removePaginationScrollButtons();
        });
    },
    updated: function () {
        this.removePaginationScrollButtons();
    },
    computed: {
        dropdownIsOpen() {
            return this.categoryDropDown ? 'opened' : '';
        },
        chevronDirection() {
            return this.categoryDropDown ? 'fa-chevron-down' : 'fa-chevron-right';
        },
        paginatedContents() {
            const start = this.page * this.perPage - this.perPage;
            return this.contents.slice(start, start + this.perPage);
        },
    },
    methods: {
        removePaginationScrollButtons() {
            // Delete pagination scrolling buttons that are easily confused for first/last page buttons.
            let prevChunkLi = document.querySelector('.VuePagination__pagination-item-prev-chunk');
            if (prevChunkLi) {
                // prevChunkLi.parentNode.removeChild(prevChunkLi);
                prevChunkLi.style.display = 'none';
            }

            let nextChunkLi = document.querySelector('.VuePagination__pagination-item-next-chunk');
            if (nextChunkLi) {
                // nextChunkLi.parentNode.removeChild(nextChunkLi);
                nextChunkLi.style.display = 'none';
            }

            let nextPageLi = document.querySelector('.VuePagination__pagination-item-next-page');
            if (nextPageLi) {
                nextPageLi.style.display = 'block';
            }
        },
        addLabelToPaginationButtons() {
            var pageLinks = $('li .page-link');
            pageLinks.each(function () {
                var aTagValue = $(this).text();
                $(this).attr('aria-label', 'Page ' + aTagValue);
                $(this).attr('tabindex', 0);
                $(this).attr('href', '#');
            });
        },
        onlyActives(categories){
            var data=_.map(categories, function(o) {
                if (o.dop_status === "A") return o;
            })
            return _.without(data, undefined)
        },
        reloadPage(){
            if(this.content)
                this.id=this.content.sco_id
            this.renderList();
        },
        async renderList() {
            let params = {
                orderBy: 'created_at',
                order: 'desc',
                perPage: '1000',
                search: this.omniSearch
            }

            await this.$http.get(this.route, {params: params}).then(function (response) {
                this.contents = response.data.data;
                if (this.permanentContents.length < 1) {
                    this.permanentContents = this.contents;
                }
            })
            if(this.id){
                var id=this.id
                var content=_.find(this.contents, function(cont) {
                    return cont.sco_id === id;
                });
                this.show(content)
            }
            this.contents=_.filter(this.contents,{sco_show_in_listing:1})
            if (this.contents.length > 5) {
                this.showPagination = true;

                setTimeout(() => {
                    this.createSelectPerPage();
                }, 0);
            }
        },
        loadData() {
            this.$http.get(this.route + '/load-category' ).then(function (response) {
                this.categories = _.sortBy(response.data, [
                    function (item) { return item.dop_name; }
                ], ["asc"]);
                if(this.permanentCategories === 'waiting') {
                    this.permanentCategories = this.categories;
                }
            })
        },
        show(content) {
            if(content != null){
                content.sco_desc_long=content.sco_desc_long.replace("<iframe", "<iframe width='100%' height='500px'");
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.content=content
            this.render('view')
        },
        render(param) {
            switch (param) {
                case 'list':
                    $('.has-error').removeClass('has-error')
                    $('.help-block').remove()
                    this.view = false
                    this.list = !this.view
                    break;
                case 'view':
                    $('.has-error').removeClass('has-error')
                    $('.help-block').remove()
                    this.view = true
                    this.list = !this.view
                    break;
                default:
                    this.view = false
                    this.list = !this.view
                    this.resetForm()
            }
        },
        getContentStyle(content, default_style) {
            return content.sco_featimg
                ? 'background:url(\'' + content.sco_featimg + '\')no-repeat center center;background-size: cover;'
                : default_style;
                // : 'background:url(/images/sb_resource.png)no-repeat center center;background-size: cover;';
        },
        createSelectPerPage() {
            const infoBlock = document.getElementsByClassName('VuePagination__count')[0];

            if (infoBlock && !document.getElementById('select-per-page')) {
                const selectPerPage = document.createElement('select');
                selectPerPage.id = 'select-per-page';
                selectPerPage.title = 'select-per-page';
                selectPerPage.innerHTML = '<option value="6" selected>6</option><option value="12">12</option><option value="18">18</option><option value="24">24</option><option value="48">48</option>';
                selectPerPage.addEventListener('change', this.changePerPage, false);

                infoBlock.parentNode.insertBefore(selectPerPage, infoBlock.nextSibling);
            }
        },
        changePerPage() {
            this.page = 1;
            this.perPage = parseInt(document.getElementById('select-per-page').value);
        },
        wellnessrewardPage(){
            return window.location.href.endsWith('wellness-rewards');
        }
    },
}
</script>

